import React, { useState } from "react";
import { Helmet } from "react-helmet"; // ✅ Import Helmet
import "../styles/Faq.css";

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Who is Reddy Anna Book?",
      answer:
        "Reddy Anna Book is an online gaming platform that offers a diverse range of sports games, live casinos, and betting options. Our goal is to provide users with an exciting and secure environment for online entertainment.",
    },
    {
      question: "How do I register on Reddy Anna?",
      answer:
        "To register on Reddy Anna, click on the WhatsApp Us Button on our homepage. Chat to our team to create your account by providing the required information. Once registered, you can start exploring and enjoying our games.",
    },
    {
      question: "Is Reddy Anna Book legal and safe?",
      answer:
        "Yes, Reddy Anna Book operates with a commitment to user security and fairness. We ensure encrypted transactions and responsible gaming practices to provide a safe user experience.",
    },
    {
      question: "What games are available on Reddy Anna Book?",
      answer:
        "Reddy Anna Book offers a wide variety of games, including cricket betting, football, tennis, live casino games, teen patti, and more to keep users engaged.",
    },
    {
      question: "How can I deposit money into my Reddy Anna account?",
      answer:
        "You can deposit money using UPI, bank transfer, and other supported payment gateways. Contact support via WhatsApp for step-by-step assistance.",
    },
    {
      question: "How do I withdraw my winnings?",
      answer:
        "To withdraw your winnings, contact the Reddy Anna support team via WhatsApp. Provide your account details, and your withdrawal will be processed promptly.",
    },
    {
      question: "Can I use Reddy Anna Book on mobile?",
      answer:
        "Yes, Reddy Anna Book is fully optimized for mobile devices. You can enjoy a seamless gaming experience on both Android and iOS smartphones.",
    },
    {
      question: "What should I do if I forget my login details?",
      answer:
        "If you forget your login details, contact our customer support on WhatsApp. They will help you recover your account securely.",
    },
    {
      question: "Is there any customer support available?",
      answer:
        "Yes, Reddy Anna provides 24/7 customer support through WhatsApp to assist users with any queries or technical issues.",
    },
    {
      question: "Are there any bonuses or promotions for new users?",
      answer:
        "Yes, Reddy Anna Book often offers welcome bonuses and ongoing promotions. Contact support for the latest offers and eligibility details.",
    },
  ];  

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // ✅ Structured Data for FAQs
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <div className="faq-section">
      {/* ✅ Inject JSON-LD in <head> */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <h2 className="faq-title">
        Frequently Asked <span className="highlight">Questions</span>
      </h2>

      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              {index + 1}. {faq.question}
              <span
                className={`faq-arrow ${activeIndex === index ? "up" : "down"}`}
              ></span>
            </div>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
